export enum ConstructionMethodType {
    Profi = 'profi',
    DIY = 'diy',
}
